// MyFunctionalComponent.tsx
import React, {useCallback, useEffect, useRef, useState} from 'react';
import styles from './BookingWidget.module.scss'; // Replace with your actual CSS module import
import {ReactComponent as CalendarIcon} from "../../../assets/images/svg/CalendarIconWhite.svg";
import {ReactComponent as ClockIcon} from "../../../assets/images/svg/ClockIconWhite.svg";
import {ReactComponent as InfoIcon} from "../../../assets/images/svg/InfoIcon.svg";
import {ReactComponent as CloseIcon} from '../../../assets/images/svg/CloseIconOutline.svg';


import {useNavigate} from "react-router-dom";
import Calendar from "../SearchComponent/Calendar.component";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers/types";
import {scheduler} from "timers/promises";
import {start} from "repl";
import socket from "../../../socket";
import {useSocketSlots} from "../../../hooks/useSocketSlots";
import {isBusyInterval, isEditSlotBlocked, clearSlotCache, throttle} from "../../../utils/slotUtils";
import {memo, useMemo} from "react";

interface Slot {
    start: number;
    end: number;
    date: Date;
    amOrPm?: string;
}

interface RoomProps {
    date: string;
    multiple?: boolean;
    preselected?: any[];
    mode?: string;
    buttonText?: string;
    hours: number;
    callback: (selectedHours: Slot[], amount: any) => void;
    room: {
        bookedSlots: { start: number; end: number; date: string }[];
        price: string;
        priceSuffix: string;
        oldPrice: string;
        minHours: number;
        defaultHours?: number;
        _id: string;
        schedule?: any;
    };
}

const MyFunctionalComponent: React.FC<RoomProps> = ({ date, hours, callback, room , buttonText='Book', multiple=true, mode='new', preselected=[]}) => {
    const user = useSelector((state: RootState)=>state.auth.userFull)
    
    // Используем оптимизированный хук вместо прямого управления сокетами
    const { tmpBusySlots, currentSocketId } = useSocketSlots(room._id);
    
    const [selectOpen, setSelectOpen] = useState(false);
    const [selectedHours, setSelectedHours] = useState<Slot[]>(() => {
        if (mode === 'edit' && preselected?.length) {
            const orig = preselected[0];
            // «обнуляем» дату до полуночи локальной зоны
            const utc = new Date(orig.date);
            const local = new Date(utc.getTime() + utc.getTimezoneOffset()*60000);
            local.setHours(0,0,0,0);
            console.log({ start: orig.start, end: orig.end, date: local })
            return [{ start: orig.start, end: orig.end, date: local }];
        }
        return [];
    });
    const [dates, setDates] = useState<{ formatted: string; clear: Date; dw: string }[]>([]);
    const [showGradient, setShowGradient] = useState(true);
    const navigation = useNavigate()
    const [timeIntervals, setTimeIntervals] = useState<string[]>([
        '01 am - 02 am',
        '02 am - 03 am',
        '03 am - 04 am',
        '04 am - 05 am',
        '05 am - 06 am',
        '06 am - 07 am',
        '07 am - 08 am',
        '08 am - 09 am',
        '09 am - 10 am',
        '10 am - 11 am',
        '11 am - 12 pm',
        '12 pm - 01 pm',
        '01 pm - 02 pm',
        '02 pm - 03 pm',
        '03 pm - 04 pm',
        '04 pm - 05 pm',
        '05 pm - 06 pm',
        '06 pm - 07 pm',
        '07 pm - 08 pm',
        '08 pm - 09 pm',
        '09 pm - 10 pm',
        '10 pm - 11 pm',
        '11 pm - 12 am'
    ]);
    const [selectedInterval, setSelectedInterval] = useState<string>('1');
    const [showCalendar, setShowCalendar] = useState<boolean>(false);
    const [currentDate, setCurrentDate] = useState<any>(null)
    const [openCalendarInfo, setOpenCalendarInfo] = useState<any>(null)
    const [openHoursInfo, setOpenHoursInfo] = useState<any>(null)
    const daysMap = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const { bookedSlots, price } = room;
    const hoursTableRef = useRef<HTMLDivElement>(null);
    const [countdown, setCountdown] = useState(300); // 10 minutes in seconds
    
    // Мемоизированные значения для оптимизации
    const originalDuration = useMemo(() => 
        preselected.length > 0 ? preselected[0].end - preselected[0].start : null,
        [preselected]
    );
    useEffect(() => {
        if (mode === 'edit' && preselected && preselected.length > 0) {
            console.log(preselected)
            const orig = preselected[0];
            console.log(orig)
            setSelectedHours([{
                start: orig.start,
                end:   orig.end,
                date:  new Date(orig.date)
            }]);
        }
    }, [mode, preselected]);
    // Очищаем кэш при изменении даты или слотов
    useEffect(() => {
        clearSlotCache();
    }, [tmpBusySlots, currentDate]);

    useEffect(() => {
        if (hours && hours > 0) {
            setSelectedInterval(hours.toString());
        }
    }, [hours]);


    /**
     * Определяет, должен ли данный интервал подсвечиваться как часть текущей брони.
     * Мемоизированная версия для оптимизации производительности
     */
    const inSelected = useCallback((interval: string, dateObj: Date): string => {
        // 1. Парсим часы
        const m = interval.match(/^(\d{1,2})(?:\s*(?:am|pm))?\s*-\s*(\d{1,2})(?:\s*(?:am|pm))?$/i);
        if (!m) return '';

        const start = parseInt(m[1], 10);
        let end   = parseInt(m[2], 10);
        if (end === 0) end = 24;

        // 2. Только для режима редактирования
        if (mode === 'edit' && selectedHours.length === 1) {
            const orig = selectedHours[0];
            // Сравниваем дни через toLocaleDateString()
            if (orig.date.toLocaleDateString() === dateObj.toLocaleDateString()) {
                // Подсвечиваем каждый час внутри оригинала
                if (start >= orig.start && start < orig.end) {
                    return styles.selected;
                }
            }
            return '';
        }

        // 3. Для обычного режима new — ваша стандартная проверка пересечения
        return selectedHours.some(s => {
            return (
                s.date.toLocaleDateString() === dateObj.toLocaleDateString() &&
                s.start < end &&
                s.end > start
            );
        })
            ? styles.selected
            : '';
    }, [mode, selectedHours]);






    useEffect(()=>{
        if (date) {
            setCurrentDate(date)
        } else {
            setCurrentDate(`${new Date().getDate()}.${(new Date().getMonth() + 1).toString().padStart(2, '0')}.${new Date().getFullYear()}`)
        }

    }, [])

    useEffect(() => {
        if (preselected && preselected.length > 0 && preselected[0].date) {
            const updatedPreselected = [...preselected];
            updatedPreselected[0] = { ...updatedPreselected[0], date: new Date(preselected[0].date) };
            setSelectedHours(updatedPreselected); // Обновите selectedHours с данными из preselected
        }
    }, [preselected]);

    useEffect(()=>{
        generateDates()
    }, [currentDate])

    useEffect(()=>{
        setSelectedHours((old)=>old.filter(x=> x.end - x.start === parseInt(selectedInterval)))
    }, [selectedHours.length])

    const selectSlot = (timeInterval: string, date: Date) => {
        const m = timeInterval.match(/^(\d{1,2})(?:\s*(?:am|pm))?\s*-\s*(\d{1,2})(?:\s*(?:am|pm))?$/i);
        if (!m) return;
        const startHour = parseInt(m[1], 10);
        const dateObj = date
        // Режим переноса (edit)
        if (mode === 'edit' && originalDuration != null && selectedHours.length === 1) {
            const orig = selectedHours[0];
            if (isEditSlotBlocked(
                startHour,
                dateObj,
                originalDuration,
                bookedSlots,
                tmpBusySlots,
                { start: orig.start, end: orig.end },
                room.schedule
            )) {
                alert('Нельзя перенести — в новом диапазоне есть занятые часы или время вне рабочих часов');
                return;
            }
            const endHour = startHour + originalDuration;
            setSelectedHours([{ start: startHour, end: endHour, date: dateObj }]);
            socket.emit('clear by id');
            socket.emit('slot selected', {
                slotId: { start: startHour, end: endHour, date: dateObj },
                roomId: room._id
            });
            return;
        }

        // ==== Обычный режим: множественный выбор по interval ====
        if (!multiple) {
            setSelectedHours([]);
            socket.emit('clear by id');
        }

        const endHour = parseInt(m[2], 10);
        const idx = selectedHours.findIndex(slot =>
            slot.start === startHour &&
            slot.end === endHour &&
            slot.date.toDateString() === date.toDateString()
        );

        if (idx > -1) {
            setSelectedHours(prev =>
                prev.filter((_, i) => i !== idx)
            );
            socket.emit('slot deselected', {
                slotId: { start: startHour, end: endHour, date },
                roomId: room._id
            });
        } else {
            setSelectedHours(prev => [
                ...prev,
                { start: startHour, end: endHour, date }
            ]);
            socket.emit('slot selected', {
                slotId: { start: startHour, end: endHour, date },
                roomId: room._id
            });
        }
    };



    const openSelect = () => {
        if (mode==='edit') {
            return
        }
        setSelectOpen(true);
    };

    const toggleCalendar = () => {
        setShowCalendar(old=>!old)
    }


    const generateDates = () => {
        // Generate an array of dates for the next five days
        let today = new Date();
        if (currentDate) {
            const [day, month, year] = currentDate.split('.').map(Number);

            const date = new Date(Date.UTC(year, month - 1, day));
            today = date;
        }
        const options = { day: 'numeric', month: 'short' };
        const datesArray = [];
        for (let i = 0; i < 5; i++) {
            const date = new Date(today.getTime() + i * 24 * 60 * 60 * 1000);
            // @ts-ignore
            const formattedDate = date.toLocaleDateString(undefined, options);
            datesArray.push({ formatted: formattedDate, clear: date, dw: daysMap[date.getDay()] });
        }
        setDates(datesArray);
    };



    const generateTimeIntervals = () => {
        const intervals: string[] = [];
        // Если мы в режиме редактирования и знаем исходную длительность — шаг 1 час,
        // иначе — обычный выбранный интервал
        const step = mode === 'edit' && originalDuration
            ? 1
            : parseInt(selectedInterval, 10);

        const startTime = 8;
        const endTime = 23;

        for (let hour = startTime; hour < endTime; hour += step) {
            const from = hour;
            const to = mode === 'edit' && originalDuration
                ? hour + 1
                : hour + step;

            // Не выходим за пределы суток
            if (to <= 24) {
                const formattedFrom = from.toString().padStart(2, '0');
                const formattedTo   = to.toString().padStart(2, '0');
                intervals.push(`${formattedFrom} - ${formattedTo}`);
            }
        }

        setTimeIntervals(intervals);
    };
    useEffect(() => {
        generateTimeIntervals();
    }, [selectedInterval, mode, originalDuration]);


    function isDateBeforeToday(date: any) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set time to midnight
        date.setHours(0, 0, 0, 0); // Set time to midnight
        return date < currentDate;
    }

    function isDateTomorrow(date: any) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set time to midnight
        date.setHours(0, 0, 0, 0); // Set time to midnight
        return date > currentDate;
    }



    // Используем оптимизированную функцию с мемоизацией
    const checkBusyInterval = useCallback((timeInterval: string, dateObj: Date): boolean => {
        return isBusyInterval(
            timeInterval,
            dateObj,
            bookedSlots,
            tmpBusySlots,
            mode as 'new' | 'edit',
            selectedHours
        );
    }, [bookedSlots, tmpBusySlots, mode, selectedHours]);





    useEffect(() => {
    }, [selectedHours]);


    const isBusyTime = (timeInterval: string, date: Date): boolean => {
        // Check if the provided time interval overlaps with any busy time slot
        // const [startHour, endHour] = timeInterval.split('-').map((hour) => parseInt(hour));
        // const busySlots = bookedSlots.filter((slot) => new Date(slot.date).toDateString() === date.toDateString());
        // for (const slot of busySlots) {
        //     if (
        //         (startHour <= endHour && startHour <= slot.end && endHour >= slot.start) ||
        //         (startHour > endHour && (startHour <= slot.end || endHour >= slot.start))
        //     ) {
        //         return true;
        //     }
        // }
        return false;
    };

    useEffect(() => {
        generateDates();
        generateTimeIntervals();
    }, [selectedInterval]);

    const handleScroll = (event: any) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        const isScrolledToBottom = scrollHeight - scrollTop === clientHeight;
        setShowGradient(!isScrolledToBottom);
    };

    useEffect(() => {
        const hoursTableContainer = hoursTableRef.current;
        if (hoursTableContainer) {
            if (hoursTableContainer.scrollHeight > 100 && !showGradient) {
                hoursTableContainer.classList.add(styles['scroll-fade']);
            } else {
                hoursTableContainer.classList.remove(styles['scrollable-container']);
            }
        }
    }, [dates, timeIntervals, selectedHours, showGradient, preselected]);


    const hoursCount = selectedHours.reduce((totalHours, interval) => {
        const startHour = interval.start;
        const endHour = interval.end === 0 ? 24 : interval.end;
        const hourDiff = endHour >= startHour ? endHour - startHour : 24 - startHour + endHour;
        return totalHours + hourDiff;
    }, 0);

    useEffect(()=>{
        if (!preselected) {
            setSelectedHours([])
            socket.emit('clear by id')
        }
        if (room && room.minHours) {
            // setSelectedInterval(room.minHours.toString())
            // if (room.defaultHours && room.defaultHours > room.minHours) {
            //     setSelectedInterval(room.defaultHours.toString())
            // }
        }
    }, [room])

    const mergeTimeSlots = (slots: any[]) => {
        const sortedSlots = slots.sort((a, b) => {
            if (a.date < b.date) {
                return -1;
            }
            if (a.date > b.date) {
                return 1;
            }
            if (a.start < b.start) {
                return -1;
            }
            if (a.start > b.start) {
                return 1;
            }
            return 0;
        });

        const mergedSlots = [];
        let currentSlot = sortedSlots[0];

        for (let i = 1; i < sortedSlots.length; i++) {
            const nextSlot = sortedSlots[i];

            // Check if the currentSlot and nextSlot are adjacent and have the same date.
            if (areAdjacent(currentSlot, nextSlot) && currentSlot.date === nextSlot.date) {
                currentSlot.end = nextSlot.end; // Extend the currentSlot's end time.
            } else {
                mergedSlots.push({ ...currentSlot }); // Push a copy of the currentSlot to the mergedSlots array.
                currentSlot = { ...nextSlot }; // Make a copy of the nextSlot to start a new merged slot.
            }
        }

        mergedSlots.push({ ...currentSlot }); // Push the last merged slot.
        return mergedSlots;
    };

    const areAdjacent = (slot1: { end: any; }, slot2: { start: any; }) => {
        return slot1.end === slot2.start; // Check if the end time of slot1 is equal to the start time of slot2.
    };

//

    function bookSlots() {
        // @ts-ignore
        let amount:any = parseFloat(room.price) * parseInt(selectedInterval, 10) * selectedHours.length
        if (user && user.discount) {
            amount = Math.floor((amount - amount * user.discount/100 )*100)/100
        }
        callback(mergeTimeSlots(selectedHours),amount)
    }

    return (
        <div className={styles['select-book-time-window']}>
            {(selectOpen || showCalendar) && (
                <div style={{zIndex: 10, position: "absolute", background: 'rgba(22, 26, 32, 0.50)', top: 0, bottom: 0, left: 0, right: 0}} onClick={()=>{
                    setShowCalendar(false)
                    setSelectOpen(false)
                }}/>
            )}
            <div className={'row justify-content-between mb-20'}>
                <div className={'row gap-20 align-items-center'}>
                    {(!user || !user.discount || user.discount === 0) ? (
                        <span className={'text-price'}>
      {room.price} {room.priceSuffix}
    </span>
                    ) : (
                        <>
      <span className={'text-price'}>
        {Math.floor((parseFloat(room.price) - parseFloat(room.price) * user.discount / 100) * 100) / 100} {room.priceSuffix}
      </span>
                            <span className={'old-price crossline'}>{room.price} {room.priceSuffix}</span>
                        </>
                    )}
                </div>

                <span className={'blue-text pointer'} onClick={()=>navigation('/spots')}>More rooms</span>
            </div>
            <div className={`${styles['select-time-select']} row align-items-center pa-5 justify-content-between relative`}>
                <div className={`col-12 row align-items-center gap-20 pointer justify-content-between pr-10`}>
                    <div className={'row align-items-center  gap-10 '} onClick={toggleCalendar}>
                        <CalendarIcon/>
                        <p>{currentDate}</p>
                    </div>
                    {!openCalendarInfo && <InfoIcon onClick={() => setOpenCalendarInfo((old: any) => !old)}/>}
                    {openCalendarInfo && (<CloseIcon onClick={() => setOpenCalendarInfo((old: any) => !old)} />)}
                    {openCalendarInfo && (
                        <div className={styles.popup} style={{zIndex: 111, right: 255}}>
                            <span className={'text-black main-text text-align-center'}>Select date</span>
                        </div>
                    )}
                    {showCalendar && (
                        <Calendar selected={Number(date.split('.')[0])} dark={true} handleCancelButton={toggleCalendar} handleDateSelect={(date)=> {
                            setCurrentDate(date)
                            toggleCalendar()
                        }} />
                    )}
                </div>
                <div className={`${styles['v-divider']}`} />
                <div className={`col-12 ml-5 row align-items-center gap-20 justify-content-between relative`} style={{zIndex: 888}} >
                    <div className={`relative row align-items-center gap-20 pointer justify-content-between col-24 pr-10`} >
                        <div className={'row align-items-center  gap-10 '} onClick={openSelect}>
                            <ClockIcon />
                            <p>{selectedInterval} hour</p>
                        </div>
                        {!openHoursInfo && <InfoIcon onClick={() => setOpenHoursInfo((old: any) => !old)}/>}
                        {openHoursInfo && <CloseIcon onClick={() => setOpenHoursInfo((old: any) => !old)}/>}
                        {openHoursInfo && (
                            <div className={styles.popup} style={{zIndex: 111}}>
                                <span className={'text-black main-text text-align-center'}>Select number of hours</span>
                            </div>
                        )}
                    </div>

                    {/*<ChevronDoun className={`${styles['pointer']}`} />*/}
                </div>
                {selectOpen && (
                    <div className={`col-12 col justify-content-center gap-20 ${styles['hours-select']} `} ref={hoursTableRef}>
                        {(!room.minHours || room.minHours <  2) && (
                            <span className={`pointer ${styles['list-item']}`} onClick={() => { setSelectedInterval('1'); setSelectOpen(false); setSelectedHours([]); socket?.emit('clear by id')}}>1 hour</span>
                        )}
                        {room && room.minHours && room.minHours < 3 && (
                            <>
                                <span className={`pointer ${styles['list-item']}`} onClick={() => { setSelectedInterval('2'); setSelectOpen(false); setSelectedHours([]); socket?.emit('clear by id') }}>2 hours</span>
                                <span className={`pointer ${styles['list-item']}`} onClick={() => { setSelectedInterval('3'); setSelectOpen(false); setSelectedHours([]); socket?.emit('clear by id')}}>3 hours</span>
                            </>
                        )}

                        {room && room.minHours && room.minHours === 3 && (
                            <span className={`pointer ${styles['list-item']}`} onClick={() => { setSelectedInterval('3'); setSelectOpen(false); setSelectedHours([]); socket?.emit('clear by id')}}>3 hours</span>
                        )}
                    </div>
                )}
            </div>
            <div className={styles['scrollable-container']} onScroll={handleScroll}>
                <div className={`row justify-content-start`} style={{position: 'sticky', top: 0, zIndex: 2, background: '#343643'}}>
                    <div className={styles['border']}  style={{maxWidth: '100px', minWidth: '80px'}} />
                    {dates.map((dateItem) => (
                        <div className={styles['border']} key={dateItem.formatted} style={{maxWidth: '100px', minWidth: '75px'}}>
                            <p>{dateItem.formatted}</p>
                            <p className={'text-10'}>{dateItem.dw}</p>
                        </div>
                    ))}
                </div>
                {timeIntervals.map((timeInterval, index) => (
                    <div className="row" key={timeInterval + index}>
                        <div className={styles['border']} style={{maxWidth: '100px', minWidth: '80px'}}>
                            {mode === 'edit' ? (
                                (() => {
                                    // получаем только стартовый час
                                    const [startStr] = timeInterval.split(' - ');
                                    const endHour = (parseInt(startStr, 10) + 1).toString().padStart(2, '0');
                                    return <p>{`${startStr} - ${endHour}`}</p>;
                                })()
                            ) : (
                                <p>{timeInterval}</p>
                            )}
                        </div>
                        {dates.map((dateItem) => (
                            <div
                                className={`row align-items-center justify-content-center  ${styles['border-body']} ${checkBusyInterval(timeInterval, dateItem.clear) ? styles.busy : ''} ${inSelected(timeInterval, dateItem.clear)}`}
                                key={dateItem.formatted}
                                style={{ maxWidth: '100px', minWidth: '75px'}}
                                onClick={() => {
                                    selectSlot(timeInterval, dateItem.clear)
                                }}
                            >
                                €{price}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            {selectedHours.length > 0 && (
                <div className={'col align-items-center'}>
                    {mode!=='edit' && (
                        <span className={'magenta-text spot-title'}>{`Total cost ${(Math.floor(((parseFloat(room.price) * parseInt(selectedInterval, 10) *selectedHours.length)-(parseFloat(room.price) * parseInt(selectedInterval, 10) *selectedHours.length * (user && user.discount ? parseInt(user.discount) : 0) /100))*100))/100}€ for ${selectedHours.length * parseInt(selectedInterval, 10)} hours`}</span>
                    )}
                    <div className={'red-button row align-content-center justify-content-center mt-10 pointer wrap'} onClick={bookSlots}>
                        <span className={'red-button-text'}>{buttonText}</span>
                    </div>
                </div>
            )}
            {/*<Button className={`mt-4`} text={`Select ${hoursCount} hour(s)`} callback={selectHours} />*/}
        </div>
    );

};

export default MyFunctionalComponent;
export {};
